import { Badge } from '../../components/ui/badge';
import {
  STATUS_LABEL,
  type RequestStatus,
} from '../../services/supportRequest.service';
import { parseApiDate, relativeLabel, useNow } from './time';

/**
 * Status colouring carries the one thing a customer scanning the list wants to
 * know: is the ball in my court. "Awaiting you" is the only warm colour, so it
 * stands out against everything that's on us.
 */
const STATUS_CLASS: Record<RequestStatus, string> = {
  awaiting_pliable:
    'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300 border-transparent',
  awaiting_customer:
    'bg-amber-100 text-amber-900 dark:bg-amber-950 dark:text-amber-300 border-transparent',
  in_progress:
    'bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-300 border-transparent',
  done: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border-transparent',
  declined: 'bg-muted text-muted-foreground border-transparent',
};

export function StatusBadge({ status }: { status: RequestStatus }) {
  return (
    <Badge variant="outline" className={`h-5 px-2 text-[11px] ${STATUS_CLASS[status]}`}>
      {STATUS_LABEL[status]}
    </Badge>
  );
}

export function RelativeTime({ iso }: { iso?: string | null }) {
  const now = useNow();
  if (!iso) return null;

  const label = relativeLabel(iso, now);
  if (!label) return null;

  return (
    <time dateTime={iso} title={new Date(parseApiDate(iso)).toLocaleString()}>
      {label}
    </time>
  );
}
